import styled from 'styled-components';
import { Box } from '@mantine/core';
import type { ComponentProps } from 'react';
import { asPlainComponent } from '@dealstack/frontend/shared/utils/asPlainComponent';

const PlainBox = asPlainComponent<ComponentProps<typeof Box>>(Box);

export const StyledFloatingContainer = styled(PlainBox)`
	padding: 0.5rem;
	display: flex;
	flex-wrap: wrap;
	width: fit-content;
	max-width: 90%;
	width: fit-content;
	justify-content: center;
	align-items: center;
	gap: 0.5rem;
	border-radius: 4px;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[0]};
	box-shadow: 0 4px 8px 0 #91969833;
	background: ${({ theme }) => theme.v3.colors.white[0]};
	position: sticky;
	margin: auto auto 0;
	bottom: 2rem;
`;
